import React, { useCallback } from 'react';
import BottomNavigation from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/BottomNavigation';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { MOBILE_MENU_FROM_BOTTOM, useLayoutContext } from 'Context/LayoutContext';
import { ActionContextProvider } from './ActionCtx';
import { Action } from './Action';
import { ClientNavPicker } from './ClientNavPicker';

const useStyles = buildUseStyles('BottomNav', (theme) => ({
  bottomNavRoot: {
    width: '100vw',
    bottom: 0,
    position: 'fixed',
    // When a page adds an app bar as a header, that needs to use the appBar zIndex.
    // If you have such a page open and tap on the menu, the drawer that opens also needs to use the appBar zIndex to appear on top of that header.
    // But that drawer shouldn't be on top of this bottom nav!
    // Can't go up to the next zIndex (sideBar, which should appear on top of the BottomNav), so instead add 1 to the zIndex to keep this on top of the drawer.
    zIndex: theme.zIndex.appBar + 1,
  },
  spacing: {
    // Without this, other elements can be covered up by the nav
    marginBottom: theme.heights.mobileBottomNavigationHeight,
  },
}));

export const BottomNav = () => {
  const classes = useStyles();
  const { showMobileMenuFrom, setShowMobileMenuFrom } = useLayoutContext();
  const closeMenuIfOpen = useCallback(() => setShowMobileMenuFrom(null), []);

  // BE CAREFUL ADJUSTING ELEMENTS IN <BottomNavigation>!
  // EVEN THE SLIGHTEST ADJUSTMENT SHOULD BE CHECKED ON AN iPhone SE 2 SCREEN (375px wide), AND useCallbacks ARE NEEDED
  return (
    <>
      <ActionContextProvider menuItemValue="menu">
        <BottomNavigation className={classes.bottomNavRoot}>
          <ClientNavPicker onClick={closeMenuIfOpen} />
          <Action
            value="menu"
            label="Menu"
            icon="menu"
            onClick={useCallback(() => setShowMobileMenuFrom(from => (from === MOBILE_MENU_FROM_BOTTOM ? null : MOBILE_MENU_FROM_BOTTOM)), [])}
            selectedIf={useCallback(() => showMobileMenuFrom, [showMobileMenuFrom])}
          />
        </BottomNavigation>
      </ActionContextProvider>
      <div className={classes.spacing} />
    </>
  );
};
